import React, { FC } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';

const StCampaignContainer = styled.p`
    position: relative;
    display: block;
`;

type Props = {
    readonly endDate: number;
};

export function getCampaignDaysLeft(endDateInMs: number, t: TFunction) {
    const today = new Date();
    today.setUTCSeconds(0);
    today.setUTCMinutes(0);
    today.setUTCHours(0);
    today.setUTCMilliseconds(0);
    const MS_TO_DAY = 86400000;
    const daysLeft = Math.ceil((endDateInMs - today.getTime()) / MS_TO_DAY);

    let daysLeftString = '';
    if (daysLeft < 0) {
        daysLeftString = t('marketing.yourCampaigns.sale.saleEnded');
    } else if (daysLeft < 1) {
        daysLeftString = t('marketing.yourCampaigns.sale.saleEndsToday');
    } else {
        daysLeftString = t('marketing.yourCampaigns.sale.saleEndsIn', {
            count: daysLeft
        });
    }

    return [daysLeftString, daysLeft];
}

const ProductCampaignEndDate: FC<Props> = props => {
    const { t } = useTranslation();
    return <StCampaignContainer>{getCampaignDaysLeft(props.endDate, t)[0]}</StCampaignContainer>;
};

export default ProductCampaignEndDate;
